export const formatToLocalDate = stringDate => {
  if (stringDate) {
    stringDate = stringDate.replace(" ", "T");
    let date = new Date(stringDate + "Z");
    let items = date.toString().split(" ");
    let out = items[1] + "-" + items[2] + "-" + items[3] + " " + items[4];
    return out.substring(0, out.length - 3);
  } else {
    return null;
  }
};

export const formatRelativeTime = (stringDate) => {
  if (!stringDate) {
    return null;
  }

  const normalized = stringDate.replace(" ", "T");
  const date = new Date(
    normalized.endsWith("Z") ? normalized : `${normalized}Z`
  );

  if (Number.isNaN(date.getTime())) {
    return formatToLocalDate(stringDate);
  }

  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffMin < 1) {
    return "Just now";
  }
  if (diffMin < 60) {
    return `${diffMin}m ago`;
  }
  if (diffHr < 24) {
    return `${diffHr}h ago`;
  }
  if (diffDay < 7) {
    return `${diffDay}d ago`;
  }
  if (diffDay < 30) {
    return `${Math.floor(diffDay / 7)}w ago`;
  }

  return formatToLocalDate(stringDate);
};

export const formatToLocalDateWithoutTimestamp = date => {
  if (date) {
    const dateAsUTCISOString = new Date(date + " UTC").toISOString();
    return new Date(dateAsUTCISOString).toLocaleDateString(undefined, {
      month: "short",
      day: "2-digit"
    });
  }

  return null;
};

export const getPublisherAvatarUrl = (person) =>
  person?.avatar?.medium ||
  person?.avatar?.large ||
  person?.avatar?.small ||
  "";

export {
  stripInlineColors,
  stripPostInlineStyles,
  normalizeCommentHtml,
} from "./stripInlineColors";
